export const reorderArray = (array, fromIndex, toIndex) => {
  const result = [...array];
  const [removed] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, removed);
  return result;
};

export const removeFromArray = (array, index) => {
  const result = [...array];
  result.splice(index, 1);
  return result;
};

export const addToArray = (array, index, item) => {
  const result = [...array];
  result.splice(index, 0, item);
  return result;
};

export function makeNumericSort(selector = (x) => x, ascending = true) {
  return ascending
    ? (a, b) => selector(a) - selector(b)
    : (a, b) => selector(b) - selector(a);
}

export function objectifyArray(items, keySelector = (i) => i.id) {
  return items.reduce(
    (acc, item) => ({ ...acc, [keySelector(item)]: item }),
    {}
  );
}

/**
 * Collection of array utility functions for immutable array manipulation.
 * Provides methods for reordering, adding, and removing items without mutating the original array.
 */
export const ArrayUtils = {
  reorderArray,
  removeFromArray,
  addToArray,
  makeNumericSort,
  objectifyArray,
};
